/**
 * Worksheets class
 * @private
 */
export class Worksheets extends Array {
}
